/*
 * @Author: Zhouqi
 * @Date: 2025-11-27 15:54:33
 * @LastEditors: Ryan
 * @LastEditTime: 2026-01-16
 */
import dynamic from 'next/dynamic';
import React from 'react';

import ProductAvatarSkeleton from '@/3.0/ai-product-avatar/_components/product-avatar-skeleton';
import { Introduction } from '@/components/container';
import DelayedRender from '@/components/DelayRender';
import Footer from '@/components/Footer';
import Layout from '@/components/layout';
import SEOHead from '@/landing/components/SEOHead';
import { createSoftwareAppSchema } from '@/landing/utils/structuredData';

const AvatarVideoPro = dynamic(() => import('../../3.0/ai-avatar-generator/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <ProductAvatarSkeleton />
    </DelayedRender>
  ),
});

const SEOSections = dynamic(() => import('../../3.0/ai-avatar-generator/seo'), {
  ssr: true,
});

// SEO 常量
const PAGE_TITLE = 'AI Avatar Generator - Create Realistic AI Avatars | FalcoCut';
const META_DESCRIPTION =
  'Create stunning AI avatar videos with realistic lip sync and voice cloning. Turn scripts into professional videos in minutes with FalcoCut AI Avatar Generator.';
const CURRENT_URL = 'https://falcocut.ai/ai-avatar-generator';

// 结构化数据
const structuredData = createSoftwareAppSchema({
  name: 'FalcoCut AI Avatar Generator',
  description: META_DESCRIPTION,
  url: CURRENT_URL,
  ratingValue: '4.8',
  ratingCount: '2680',
  featureList: [
    'Create realistic AI avatars',
    'AI voice cloning',
    'Automatic lip sync',
    'Script to video conversion',
    'Multiple avatar styles',
    'Multi-language support',
  ],
});

const AvatarVideoProPage: React.FC & {
  getLayout?: (page: React.ReactElement) => React.ReactNode;
  getExtraContent?: () => React.ReactNode;
} = () => {
  return (
    <>
      <SEOHead
        title={PAGE_TITLE}
        description={META_DESCRIPTION}
        url={CURRENT_URL}
        imageAlt="FalcoCut AI Avatar Generator"
        publishedTime="2025-11-27"
        modifiedTime="2026-01-16"
        structuredData={structuredData}
      />

      <AvatarVideoPro />
    </>
  );
};

// 定义 getLayout 为直接返回页面本身，不使用 Layout
AvatarVideoProPage.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;

// 定义 SEO 部分和 Footer 作为额外内容，在 Layout 外渲染
AvatarVideoProPage.getExtraContent = () => {
  return (
    <Introduction>
      <SEOSections />
      <Footer />
    </Introduction>
  );
};

export const getStaticProps = async () => {
  return {
    props: {},
  };
};

export default AvatarVideoProPage;
